import React from 'react'

class AnnotationOverlay extends React.Component {
  render() {
    let annotation = this.props.annotation
    
    const style = {
      position: 'absolute',
      left: `${annotation.percent_x}%`,
      top: `${annotation.percent_y}%`,
    };

    let klass = "annotation pink accent-2 ";

    const newAnntotation = this.props.annotation.id == null ? (
      <div style={style} className={klass}>
        {this.props.annotationId}
      </div>
    ) : null
    let resolvedClass = annotation.resolved ? "resolved" : ""

    return (
      <div>
        {newAnntotation}
        <div style={style} id={this.props.popoverId} className={`ml-7 annotation-container ${resolvedClass} is-open`}>
          <div className="row">
            <div className="col-12">
              <div className="d-flex flex-column mb-15">
                {this.props.overlayContent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AnnotationOverlay
